<template>
  <workbenchDetail
    @cancelCallBack="cancel"
    @approvalConfirm="approvalConfirm"
    :backlogModel="backlogModel"
    :isHide="isHide"
  >
    <div slot="content">
      <el-form ref="form" label-width="170px" :model="dataForm">
        <el-form-item label="企业名称：" prop="UnitName">
          {{ dataForm.UnitName }}
        </el-form-item>
        <el-form-item label="单位性质：" prop="UnitNature">
          {{ dataForm.UnitNature }}
        </el-form-item>
        <el-form-item label="法人代表：" prop="LegalPerson">
          {{ dataForm.LegalPerson }}
        </el-form-item>
        <el-form-item
          label="法人手机号码："
          prop="LegalMobileNo"
          v-if="dataForm.GroupNature==0"
        >
          {{ dataForm.LegalMobileNo }}
        </el-form-item>
        <el-form-item label="单位人数：" prop="EmployeesNumber">
          {{ dataForm.EmployeesNumber }}
        </el-form-item>
        <el-form-item label="联系人（会员代表）：" prop="ContactUser">
          {{ dataForm.ContactUser }}
        </el-form-item>
        <el-form-item label="常驻地区：" prop="Address">
          {{ dataForm.Address }}
        </el-form-item>
        <el-form-item label="邮政编码：" prop="PostalCode">
          {{ dataForm.PostalCode }}
        </el-form-item>
        <el-form-item label="联系电话：" prop="Phone">
          {{ dataForm.Phone }}
        </el-form-item>
        <el-form-item label="电子邮箱：" prop="Email">
          {{ dataForm.Email }}
        </el-form-item>
        <el-form-item label="联系地址：" prop="ContactAddress">
          {{ dataForm.ContactAddress }}
        </el-form-item>
        <el-form-item label="附件：" prop="File">
          <of-upload
            class="upload-demo"
            list-type="fileList"
            @onPreview="onPreview"
            :fileList="fileList"
            :class="{ hide: hideUploadEdit }"
          >
            <div slot="content">
              <el-button>上传文件</el-button>
            </div>
          </of-upload>
        </el-form-item>
        <el-form-item label="会员级别：" prop="Level">
          {{ showLevel(dataForm.Level) }}
        </el-form-item>
        <el-form-item label="申请时间：" prop="ApplyTime_datepicker">
          {{ (dataForm.ApplyTime * 1000) | formatDate }}
        </el-form-item>
      </el-form>
    </div>
  </workbenchDetail>
</template>
<script>
import workbenchDetail from "@/modules/zjrc/pages/workbench/common/workbenchDetail";
import OfUpload from "@/components/controls/of_upload/of_upload";
import api from "@/modules/zjrc/api";
import { mapGetters } from "vuex";
import { saveAs } from "file-saver";

export default {
  name: "audit",
  props: {
    backlogModel: {
      type: Object,
      default: null,
    },
    isHide:{
      type:Boolean,
      default:false
    }
  },
  data() {
    return {
      dataForm: {}, //表单对象
      fileList: [], //附件数组
      hideUploadEdit: true, //上传按钮
    };
  },
  components: {
    workbenchDetail,
    OfUpload
  },
  computed: {
    ...mapGetters(["GetCurrentUserInfo"]),
    showLevel() {
      return (data) => {
        switch (data) {
          case 0:
            return "普通会员";
          case 1:
            return "特殊会员";
          case 2:
            return "永久会员;";
        }
      };
    },
    showGroupNature() {
      return (data) => {
        return data == 0 ? "企业" : "单位";
      };
    },
  },
  mounted() {
    let that = this;
    that.loadData();
  },
  methods: {
    //初始化数据
    loadData() {
      let that = this;
      let params = { Id: that.backlogModel.BusinessId };
      api.QueryGroupMemberById(params).then((res) => {
        if (res.data.Code == 0) {
          that.dataForm = res.data.Data;
          that.getFile();
        }
      });
    },
    //取消
    cancel() {
      this.$emit("auditCallBack", null);
    },
    //提交数据
    approvalConfirm(data) {
      let params = Object.assign({}, data);
      api
        .AuditGroupMember(params)
        .then((res) => {
          if (res.data.Code === 0) {
            this.$message({
              message: "提交成功",
              type: "success",
            });
            this.$emit("auditCallBack", params);
          } else {
            this.$message({
              message: res.data.Message,
              type: "error",
            });
          }
        })
        .catch((e) => {
          this.$message({
            message: e.toString(),
            type: "error",
          });
        });
    },
    //点击下载
    onPreview(file) {
      saveAs('/files' + file.url, file.name);
    },
    //初始化附件
    getFile() {
      if (
        this.dataForm.File === undefined ||
        this.dataForm.File === null ||
        this.dataForm.File == ""
      ) {
        return;
      }
      this.fileList = JSON.parse(this.dataForm.File);
    },
  },
};
</script>

<style scoped>
.upload-demo >>> .el-icon-close {
  display: none !important;
}
.upload-demo >>> .el-icon-close-tip {
  display: none !important;
}
.upload-demo>>>.el-upload-dragger{
    display: none !important;
}
.hide .el-button--default {
  display: none !important;
}
</style>

<style>

</style>